export const OPEN_CHANGE_REMINDER_TYPE = "OPEN_CHANGE_REMINDER_TYPE";
export const FETCH_REMINDER_TYPE_VALUES = "FETCH_REMINDER_TYPE_VALUES";
